/**
 * Bridges a `display_uri` event source to the shared QR state shape, with
 * mobile deep-link fallback. Returns an unsubscribe function.
 *
 * The caller is expected to have already emitted `{ state: 'loading' }` before
 * invoking this helper.
 */
export function subscribeDisplayUri(params) {
    const { source, resolveURI, isMobilePlatform, onQr } = params;
    return source.onDisplayUri((uri) => {
        const deepLink = resolveURI ? resolveURI(uri) : undefined;
        if (isMobilePlatform && deepLink) {
            try {
                const url = new URL(deepLink);
                if (url.protocol === 'javascript:' || url.protocol === 'data:') {
                    console.warn('Blocked navigation to untrusted URL scheme');
                    onQr({ state: 'fetched', value: uri, deepLink });
                    return;
                }
            }
            catch {
                console.warn('Blocked navigation to malformed URL');
                onQr({ state: 'fetched', value: uri, deepLink });
                return;
            }
            window.location.href = deepLink;
            return;
        }
        onQr({ state: 'fetched', value: uri, deepLink });
    });
}
